import { useQuery } from "@tanstack/react-query"
import { useApi } from "./useApi"

const useCompanies = (query?: string) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading-companies", query],
    () => scientApi.trading.getTradingCompanies({ query }),
    {
      retry: 1,
      staleTime: Infinity,
      enabled: !!query && query.length >= 1, // Only fetch when user has typed at least 1 char
    },
  )

  return {
    companies: data,
    error,
    isLoading,
  }
}

export default useCompanies
